import * as React from "react";
import PropTypes, { object } from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./tabs.css";
import { TabsTable } from "./tabsTable";
import { useDispatch, useSelector } from "react-redux";
import { Modules } from "../../common/constants/sidebar";
import { getMappedProjectManagementData } from "../../redux/actions/project-management";
// import { withStyles } from "@mui/styles";
import {TabScrollButton, Tooltip} from "@mui/material";
import styled from "@emotion/styled";
import { blue } from "@mui/material/colors";
import { pdfIcon, searchIcon } from "../../common/icons";
import { EMPLOYEE_USER_MANUAL_LINK } from "../../common/constants/extra-constants";
import { Settings } from "../Settings/settings";
import MyAssignedTasks from "../MyAssignedTasks/MyAssignedTasks";
import VeersaPointsDashboard from "../VeersaPoints/VeersaPointsDashboard";
import VeersaPointsAdminDashboard from "../VeersaPoints/VeersaPointsAdminDashboard";
import {
  buildTrainingAndSessionTabs,
  POINTS_DASHBOARD_TAB,
  VEERSA_POINTS_TAB,
} from "../VeersaPoints/trainingSessionVeersaTabs";


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({headingName, value, setValue, tabIndex, periodWeek, setTabIndex, setPeriodWeek}) {
  const { userData } = useSelector(({ USER }) => USER);
  
  const resourceAllObj = { 0: "Dashboard", 2:"expiring allocations",3:"Multi Projects Allocation", 6:"Bench Resources"}
  const dispatch = useDispatch();
  // const [value, setValue] = React.useState(0);
  const [status, setStatus] = React.useState("")
  const [noDataFound, setNoDataFound] = React.useState(false)
  const { mappedProjectManagementData  } = useSelector(({ MODULES }) => MODULES);
  const { vTrackLoader } = useSelector(({ APP_STATE }) => APP_STATE);
  const inputRef = React.useRef("");
  const [searchData,setSearchData] = React.useState('')
  const [projectsTabs,setProjectsTabs]= React.useState('')
  let counter = 0, count = 0;

  const MyTabScrollButton = styled(TabScrollButton)({
    '&.Mui-disabled': {
        width: 0,
    },
    overflow: 'hidden',
    transition: 'width 0.5s',
    width: 28,
    color: '#073044',
    backgroundColor: '#fafafa'
  });

  const handleChange = (event, newValue) => {
    if(headingName === Modules.PROJECT_ALLOCATION){
      if(newValue === 0) setStatus("All");
      else if(newValue === 1) setStatus("Active");
      else if(newValue === 2) setStatus("History");
    }
    setValue(newValue);
    setTabIndex(null);
    setPeriodWeek(null);
  };

  const createSearchBox = (placeHolder) => {
    return(
      <div className = "searchWrapper" style={{marginBottom:10}}>
            <img src={searchIcon} className = "searchIcon" alt=""/>
            <input
              className="searchBox"
              type = "search"
              placeholder={placeHolder}
              ref={inputRef}
              onChange={setSearchDataHelper}
              />
      </div>
    )
  }
  const setSearchDataHelper = (e) =>{
    if (e.target.value.length > 2 || e.target.value.length ===0)
    setSearchData(e.target.value); 
  }

  const setProjectTabsData = ()=>{
    let projectsTab = [];
    if(mappedProjectManagementData){
      mappedProjectManagementData.forEach((client) => {
        client.projects.forEach((project) => {
          projectsTab.push({
            projectName : project.projectName,
            clientName : client.clientName,
            projectId : project.projectId
          });
        });
      });
      setProjectsTabs(projectsTab.sort(function(a,b){return (a.projectName).localeCompare(b.projectName)}))
  }
}
  
  React.useEffect(() => {
    if (headingName === Modules.PROJECT_ALLOCATION) {
      setValue(1);
    } else {
      // Project Allocation's "Active" sub-tab is index 1; other modules use 0-based tabs. Reset
      // when switching modules (e.g. to SOW) so the previous value does not align with the wrong tab.
      setValue(0);
    }
    setStatus("Active");
  }, [ headingName, setValue ]);
  
  React.useEffect(() => {
    if(headingName === Modules.PROJECT_MANAGEMENT || headingName === Modules.TIMESHEET) {
      dispatch(getMappedProjectManagementData());
      if(tabIndex !== null && periodWeek !== null){
        setValue(tabIndex);
      }
    }
  }, [ headingName ]);
  
  React.useEffect(() => {
    if((mappedProjectManagementData===null || mappedProjectManagementData.length===0) && headingName === Modules.PROJECT_MANAGEMENT) setNoDataFound(true);
    else {
      setNoDataFound(false);
      setProjectTabsData();
    };
  },[mappedProjectManagementData, headingName]);
  
  React.useEffect(()=>{
    if (searchData){
      
      const elementsThatContainString = projectsTabs.filter(element=> element.projectName.toString().toLowerCase().includes(searchData.toLowerCase()));
      const elementsThatDoNotContainString = projectsTabs.filter(element => !element.projectName.toString().toLowerCase().includes(searchData.toLowerCase()));
      setProjectsTabs([...elementsThatContainString, ...elementsThatDoNotContainString])
    }
    else {
      setProjectTabsData();
    }
  },[searchData]);

  return (
    <Box sx={{ width: "100%" }}>
      <div>
      {headingName===Modules.PROJECT_MANAGEMENT && createSearchBox("Search Project")}
      </div>
      {!vTrackLoader && noDataFound && headingName===Modules.PROJECT_MANAGEMENT && <h1 className="no-data">Currently you are not Project Manager in any Project. </h1>}
      <Box>
        {headingName === Modules.PROJECT_MANAGEMENT ? 
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            ScrollButtonComponent={MyTabScrollButton}
            variant="scrollable"
            scrollButtons="auto"
          >
            { projectsTabs && projectsTabs.map((project) =>{
                return <Tab key={`${project.clientName} / ${project.projectName}`} className="tabs-table" label={`${project.projectName} (${project.clientName})`} {...a11yProps(project.projectId)} />
              })}
          </Tabs> :
        headingName === Modules.TIMESHEET ? 
          (userData?.data?.roleName === "Operational Admin" ? (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              ScrollButtonComponent={MyTabScrollButton}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab className="tabs-table" label="MY TIMESHEET" {...a11yProps(0)} />
              {/* <Tab className="tabs-table" label="REPORTEES" {...a11yProps(1)} /> */}
              <Tab className="tabs-table" label="PENDING APPROVAL" {...a11yProps(1)} />
            </Tabs>
          ) : userData && userData.data.tabs.timeSheet && (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              ScrollButtonComponent={MyTabScrollButton}
              variant="scrollable"
              scrollButtons="auto"
            >
              {userData.data.tabs.timeSheet.map((tab, index) => (
                <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)} />
              ))}
            </Tabs>
          )) : 
        headingName === Modules.PROJECT_ALLOCATION ? 
        (userData?.data?.roleName === "Operational Admin" ? (
          <>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              ScrollButtonComponent={MyTabScrollButton}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab className="tabs-table" label="ALLOCATION DASHBOARD" {...a11yProps(0)} />
            </Tabs>
            {
                <Tooltip title={<h2>User Guide for vTrack</h2>}>
                    <a href={EMPLOYEE_USER_MANUAL_LINK} style={{textDecoration: 'None'}} target="_blank">
                      <button style={{ minHeight: '0'}} className="MuiTab-textColorPrimary tabs-table css-1h9z7r5-MuiButtonBase-root-MuiTab-root">
                        <div style={{display: 'flex',alignItems: 'center', gap: '0.5rem'}}>
                          <div>User Guide</div>
                            <img src={pdfIcon} />
                        </div>
                      </button>
                    </a>
                </Tooltip>
              }
          </>
        ) : userData && userData.data.tabs.projectAllocation && (
          <>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              ScrollButtonComponent={MyTabScrollButton}
              variant="scrollable"
              scrollButtons="auto"
            >
              {userData.data.tabs.projectAllocation
                .filter(tab => tab !== "DEVIATIONS" && tab !== "Deviations") // Comment out DEVIATIONS tab
                .map((tab, index) => (
                <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)} />
              ))}
            </Tabs>
            {
                <Tooltip title={<h2>User Guide for vTrack</h2>}>
                    <a href={EMPLOYEE_USER_MANUAL_LINK} style={{textDecoration: 'None'}} target="_blank">
                      <button style={{ minHeight: '0'}} className="MuiTab-textColorPrimary tabs-table css-1h9z7r5-MuiButtonBase-root-MuiTab-root">
                        <div style={{display: 'flex',alignItems: 'center', gap: '0.5rem'}}>
                          <div>User Guide</div>
                            <img src={pdfIcon} />
                        </div>
                      </button>
                    </a>
                </Tooltip>
              }
          </>
        )) :
      headingName === Modules.REPORTING ?
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {userData.data.tabs.reporting.map((tab, index) => (
            <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)} />
          ))}
        </Tabs> : 
      headingName === Modules.INVOICE_TRACKER ? 
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {userData.data.tabs.invoiceTracker.map((tab, index) => (
            <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)} />
          ))}
        </Tabs> :
      headingName === Modules.SETTINGS ?
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {userData.data.tabs.settings.map((tab, index) => (
            <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)} />
          ))}
        </Tabs> :
        headingName === Modules.SKILLS ?
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {userData.data.tabs.skillTracker.map((tab, index) => (
            <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)} />
          ))}
        </Tabs>:
        headingName === Modules.VIEW_ATTENDANCE ?
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {userData?.data?.roleName === "Operational Admin" ? (
            userData.data.tabs.viewAttendance.map((tab,index)=>(
              <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)}/>
            ))
          ) : (
            userData.data.tabs.viewAttendance.map((tab,index)=>(
              <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)}/>
            ))
          )}
        </Tabs>:
        headingName === Modules.TRAINING_AND_SESSION?
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {buildTrainingAndSessionTabs(userData).map((tab, index) => (
              <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)}/>
            ))}
        </Tabs>:
        headingName === Modules.CORRECT_ATTENDANCE?
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {userData?.data?.roleName === "Operational Admin" ? (
            <Tab className="tabs-table" label="REGULARIZE ATTENDANCE" {...a11yProps(0)}/>
          ) : (
            userData?.data?.tabs?.correctAttendance?.map((tab,index)=>(
              <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)}/>
            ))
          )}
        </Tabs>:
        headingName === Modules.RESOURCE_ALLOCATION?
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          ScrollButtonComponent={MyTabScrollButton}
          variant="scrollable"
          scrollButtons="auto"
        >
          {userData?.data?.roleName === "Project Manager" ? (
            // For Project Manager, only show Expiring Allocations and Bench Resources
            ["expiring allocations", "Bench Resources"].map((tab, index) => (
              <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)}/>
            ))
          ) : (
            // For other roles (Admin, etc.), show all tabs
            Object.values(resourceAllObj).map((tab, index) => (
              <Tab key={index} className="tabs-table" label={tab} {...a11yProps(index)}/>
            ))
          )}
        </Tabs>:
        null
      }
      </Box>
      {headingName === Modules.POINTS_DASHBOARD ? (
        userData?.data?.roleName === "Admin" ? (
          <VeersaPointsAdminDashboard />
        ) : (
          <Box sx={{ p: 2 }}>
            <Typography>You do not have access to this module.</Typography>
          </Box>
        )
      ) : headingName === Modules.VEERSA_POINTS ? (
        <VeersaPointsDashboard />
      ) : headingName === Modules.MY_TASKS ? (
        <MyAssignedTasks />
      ) : headingName === Modules.PROJECT_MANAGEMENT ? 
        projectsTabs && projectsTabs.map((project) => {
          return <TabPanel key={`${project.clientName} / ${project.projectName}`} value={value} index={counter++} >
            <TabsTable headingName={headingName} tabName={project.projectName} status={status} projectId={project.projectId} queryPeriodWeek={null}/>
          </TabPanel>
        }) :
      headingName === Modules.TIMESHEET ? 
        (userData?.data?.roleName === "Operational Admin" ? (
          <>
            <TabPanel key={0} value={value} index={0}>
              <TabsTable headingName={headingName} tabName="MY TIMESHEET" status={status} projectId={null} queryPeriodWeek={periodWeek}/>
            </TabPanel>
            <TabPanel key={1} value={value} index={1}>
              <TabsTable headingName={headingName} tabName="PENDING APPROVAL" status={status} projectId={null} queryPeriodWeek={periodWeek}/>
            </TabPanel>
            {/* Keep REPORTEES TabPanel hidden but functional for button functionality */}
            <TabPanel key={2} value={value} index={-1} style={{display: 'none'}}>
              <TabsTable headingName={headingName} tabName="REPORTEES" status={status} projectId={null} queryPeriodWeek={periodWeek}/>
            </TabPanel>
          </>
        ) : (
          userData && userData.data.tabs.timeSheet.map((tab, index) => (
            <TabPanel key={index} value={value} index={index}>
              <TabsTable headingName={headingName} tabName={tab} status={status} projectId={null} queryPeriodWeek={periodWeek}/>
            </TabPanel>
          ))
        )) :
      headingName === Modules.PROJECT_ALLOCATION ? 
        (userData?.data?.roleName === "Operational Admin" ? (
          <TabPanel key={0} value={value} index={0}>
            <TabsTable headingName={headingName} tabName="ALLOCATION DASHBOARD" status={status} projectId={null} queryPeriodWeek={null}/>
          </TabPanel>
        ) : (
          userData && userData.data.tabs.projectAllocation
            .filter(tab => tab !== "DEVIATIONS" && tab !== "Deviations") // Comment out DEVIATIONS tab
            .map((tab, index) => (
            <TabPanel key={index} value={value} index={index}>
              <TabsTable headingName={headingName} tabName={tab} status={status} projectId={null} queryPeriodWeek={null}/>
            </TabPanel>
          ))
        )) :
      headingName === Modules.REPORTING ? 
        userData && userData.data.tabs.reporting.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
          </TabPanel>
        )) :
      headingName === Modules.INVOICE_TRACKER ? 
        userData && userData.data.tabs.invoiceTracker.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
          </TabPanel>
        )) :

        headingName === Modules.SKILLS ? 
        userData && userData.data.tabs.skillTracker.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
          </TabPanel>
        )) :

        headingName === Modules.VIEW_ATTENDANCE ? 
        (userData?.data?.roleName === "Operational Admin" ? (
          userData && userData.data.tabs.viewAttendance.map((tab, index) => (
            <TabPanel key={index} value={value} index={index}>
              <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
            </TabPanel>
          ))
        ) : (
          userData && userData.data.tabs.viewAttendance.map((tab, index) => (
            <TabPanel key={index} value={value} index={index}>
              <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
            </TabPanel>
          ))
        )) :
        headingName === Modules.TRAINING_AND_SESSION?
        (
          userData && buildTrainingAndSessionTabs(userData).map((tab, index) => (
            <TabPanel key={index} value={value} index={index}>
              {tab === VEERSA_POINTS_TAB ? (
                <VeersaPointsDashboard />
              ) : tab === POINTS_DASHBOARD_TAB ? (
                userData?.data?.roleName === "Admin" ? (
                  <VeersaPointsAdminDashboard />
                ) : (
                  <Box sx={{ p: 2 }}>
                    <Typography>You do not have access to this module.</Typography>
                  </Box>
                )
              ) : (
                <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
              )}
            </TabPanel>
          ))
        ) :
        headingName === Modules.CORRECT_ATTENDANCE?
        (userData?.data?.roleName === "Operational Admin" ? (
          <TabPanel key={0} value={value} index={0}>
            <TabsTable headingName={headingName} tabName="REGULARIZE ATTENDANCE" status={null} projectId={null} queryPeriodWeek={null}/>
          </TabPanel>
        ) : (
          userData?.data?.tabs?.correctAttendance?.map((tab, index) => (
            <TabPanel key={index} value={value} index={index}>
              <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
            </TabPanel>
          ))
        )) :
      headingName === Modules.SETTINGS ? 
          (userData && userData.data.tabs.settings.map((tab, index) => (
          <TabPanel key={index} value={value} status={status} index={index}>
            <Settings tabName={tab} />
          </TabPanel>
          ))) :
          headingName === Modules.RESOURCE_ALLOCATION ?
          (userData?.data?.roleName === "Project Manager" ? (
            // For Project Manager, only show Expiring Allocations and Bench Resources panels
            ["expiring allocations", "Bench Resources"].map((tab, index) => (
              <TabPanel key={index} value={value} index={index}>
                <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
              </TabPanel>
            ))
          ) : (
            // For other roles (Admin, etc.), show all panels
            Object.values(resourceAllObj).map((tab, index) => (
              <TabPanel key={index} value={value} index={index}>
                <TabsTable headingName={headingName} tabName={tab} status={null} projectId={null} queryPeriodWeek={null}/>
              </TabPanel>
            ))
          )) :
      <TabsTable headingName={headingName} tabName='' status={status}  projectId={null} queryPeriodWeek={null}/>
    }
    </Box>
  );
}
